import { StripedTableRow as StyledTableRow } from '@edge/spark/ui-mui'
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, styled } from '@mui/material'

const rows = [
    { name: 'Make', prefix: 'make:', example: 'make:Ford' },
    { name: 'Model', prefix: 'model:', example: 'model:F150' },
    { name: 'Color', prefix: 'color:', example: 'color:green' },
    { name: 'Year', prefix: '> < - +', example: '<2005 or 2005-2010' },
    { name: 'Odometer', prefix: '> < - +', example: '>20000 or 10000+' },
    { name: 'Condition Report', prefix: 'cr:', example: 'cr:yes or cr:no' },
    { name: 'Photos', prefix: 'photos:', example: 'photos:5 or photos:0' },
]

export const StyledTable = styled(Table)(({ theme }) => ({
    minWidth: 'auto',
    '& td, & th': {
        fontSize: '14px',
    },
    'thead th': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: '15px',
        fontWeight: 'bolder',
    },
}))

const VehicleHelpTab = () => {
    return (
        <Paper sx={{ width: '100%', mt: 2, overflowX: 'auto' }}>
            <StyledTable aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left">Search</TableCell>
                        <TableCell align="center">Prefix</TableCell>
                        <TableCell align="center">Example</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <StyledTableRow key={row.name}>
                            <TableCell align="left">{row.name}</TableCell>
                            <TableCell align="center">{row.prefix}</TableCell>
                            <TableCell align="center">{row.example}</TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </StyledTable>
        </Paper>
    )
}

export default VehicleHelpTab
